//
// format currency fields to two decimal points
//

var formatCurrencyInputsTwoDecimalPoints = (function () {
    'use strict';

    // Variables

    const $currencySelector = "Textbox-39-custom-10";

    // Methods
    $(document).ready(function () {
        $(".currency").change(formatCurrency);
    });

    function formatCurrency(){
        $(this).val(parseFloat($(this).val()).toFixed(2));
    };

})();
